// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__UFEM6","loader-spin":"loader_loader-spin__9ZLak"};